export { default as DiscountVoucherSlot } from './DiscountVoucherSlot';
